import SearchIcon from "@material-ui/icons/Search";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import SettingsIcon from "@material-ui/icons/Settings";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import {
  CUSTOMER_UI_BASE_PATH,
  BOSSFOTOS_INFO_WEBSITE,
} from "./v2_actions/routes";

export const itemFirstPart = [
  {
    title: "My Purchased Photos",
    icon: VideoLibraryIcon,
    href: `${CUSTOMER_UI_BASE_PATH}/purchased`,
  },
];

export const itemSecondPart = [
  {
    title: "Edit Profile",
    icon: SettingsIcon,
    href: `${CUSTOMER_UI_BASE_PATH}/editprofile`,
  },
  {
    title: "Help-FAQs",
    icon: HelpOutlineIcon,
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/info-centre`,
  },
];

export const itemThirdPart = [
  {
    title: "Photographers",
    href: `/`,
    openAsWindowLocation: true,
  },
  {
    title: "Term of Service",
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/terms`,
  },
  {
    title: "Privacy Policy",
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/privacy-policy/`,
  },
];

export const itemFirstPartEventAndAlbum = [
  {
    title: "My Purchased Photos",
    icon: VideoLibraryIcon,
    href: `${CUSTOMER_UI_BASE_PATH}/purchased`,
  },
];

export const itemSecondPartEventAndAlbum = [
  {
    title: "Edit Profile",
    icon: SettingsIcon,
    href: `${CUSTOMER_UI_BASE_PATH}/editprofile`,
  },
  {
    title: "Help-FAQs",
    icon: HelpOutlineIcon,
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/info-centre`,
  },
];

export const itemThirdPartEventAndAlbum = [
  {
    title: "Term of Service",
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/terms`,
  },
  {
    title: "Privacy Policy",
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/privacy-policy/`,
  },
];

export const itemFirstPartPhotographer = [
  {
    title: "My Purchased Photos",
    icon: VideoLibraryIcon,
    href: `${CUSTOMER_UI_BASE_PATH}/purchased`,
  },
];

export const itemSecondPartPhotographer = [
  {
    title: "Help-FAQs",
    icon: HelpOutlineIcon,
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/info-centre`,
  },
];

export const itemThirdPartPhotographer = [
  {
    title: "Term of Service",
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/terms`,
  },
  {
    title: "Privacy Policy",
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/privacy-policy/`,
  },
];

export const itemFirstPartPurchased = [
  {
    title: "My Purchased Photos",
    icon: VideoLibraryIcon,
    href: `${CUSTOMER_UI_BASE_PATH}/purchased`,
  },
];

export const itemSecondPartPurchased = [
  {
    title: "Help-FAQs",
    icon: HelpOutlineIcon,
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/info-centre`,
  },
];

export const itemThirdPartPurchased = [
  {
    title: "Photographers",
    href: `/`,
    openAsWindowLocation: true,
  },
  {
    title: "Term of Service",
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/terms`,
  },
  {
    title: "Privacy Policy",
    openInNewBrowserTab: true,
    href: `${BOSSFOTOS_INFO_WEBSITE}/privacy-policy/`,
  },
];
